// eslint-disable-next-line
import RemoteObject from '../network/RemoteObject';
import platforms from './platforms';

// https://eslint.org/docs/user-guide/configuring#specifying-environments

export default {
  saveCredential(user, token) {
    this.saveCurrentUser(user);

    const clientType = platforms.getClientType();
    if (clientType === 'web') {
      localStorage.token = token;
    }
  },

  saveCurrentUser(user) {
    const clientType = platforms.getClientType();
    if (clientType === 'web') {
      localStorage.user = JSON.stringify(user);
      localStorage.userId = user.id;
      localStorage.nickName = user.nickName;
      localStorage.userType = user.userType;
      localStorage.teamAgency = user.teamAgency;
    }
  },

  hasCredential() {
    const userId = this.getUserId();
    return userId && userId > 0 && this.getToken();
  },

  clearCredential() {
    const clientType = platforms.getClientType();
    if (clientType === 'web') {
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
      localStorage.removeItem('nickName');
      localStorage.removeItem('userType');
      localStorage.removeItem('teamAgency');
      localStorage.removeItem('token');
    }
  },

  getCurrentUser() {
    switch (platforms.getClientType()) {
      case 'android_webview':
        return null; // Not support.
      case 'rn_webview':
        return null; // Not support.
      default:
        return new RemoteObject(localStorage.user ? JSON.parse(localStorage.user) : {});
    }
  },

  getUserId() {
    const webViewBridge = platforms.getClientWebViewBridge();
    if (webViewBridge) {
      const userId = webViewBridge.getUserId();
      return userId ? Number(userId) : null;
    } else {
      return localStorage.userId ? Number(localStorage.userId) : null;
    }
  },

  getNickName() {
    switch (platforms.getClientType()) {
      case 'android_webview':
        return null; // Not support.
      case 'rn_webview':
        return null; // Not support.
      default:
        return localStorage.nickName;
    }
  },

  getUserType() {
    switch (platforms.getClientType()) {
      case 'android_webview':
        return null; // Not support.
      case 'rn_webview':
        return null; // Not support.
      default:
        return localStorage.userType;
    }
  },

  isTeamAgency() {
    return localStorage.teamAgency === 'true';
  },

  getToken() {
    const webViewBridge = platforms.getClientWebViewBridge();
    if (webViewBridge) {
      return webViewBridge.getToken();
    } else {
      return localStorage.token ? localStorage.token : null;
    }
  },

  getAppInstanceId() {
    const webViewBridge = platforms.getClientWebViewBridge();
    if (webViewBridge && webViewBridge.getAppInstanceId) {
      return webViewBridge.getAppInstanceId();
    } else {
      return null;
    }
  },

  getAppVersion() {
    const webViewBridge = platforms.getClientWebViewBridge();
    if (webViewBridge && webViewBridge.getAppVersion) {
      return webViewBridge.getAppVersion();
    } else {
      return 999999;
    }
  },

  getLanguage() {
    const webViewBridge = platforms.getClientWebViewBridge();
    if (webViewBridge && webViewBridge.getLanguage) {
      return webViewBridge.getLanguage();
    } else {
      return localStorage.lang || 'en_US';
    }
  },
};
